export const APP_KEYCLOAK_TRIGGER_REFRESH_SECONDS_SYMBOL = Symbol(
  'app-keycloak-trigger-refresh-seconds',
);

export const APP_KEYCLOAK_MIN_VALIDITY_SECONDS_SYMBOL = Symbol(
  'app-keycloak-min-validity-seconds',
);

export const APP_VERBOSE_ERROR_DISPLAY_SYMBOL = Symbol(
  'app-verbose-error-display',
);

export const APP_RELOAD_ON_AUTH_TIMEOUT_SYMBOL = Symbol(
  'app-reload-on-auth-timeout',
);

export const APP_FIX_COMBINE_DATE_TIME = Symbol(
  'ME-34100-fix-combine-date-time',
);

export const APP_HTTP_FETCH_SECURITY = Symbol(
  'ME-265933-http-known-endpoint-security',
);

export const ADDRESS_DISPLAY_REMOVE_STRING_MODIFICATION = Symbol(
  'ME-337901-address-display-remove-string-modification',
);

export const APP_CLIENT_THROTTLE_SETTINGS = Symbol(
  'ME-305106-frontend-graph-ql-operation-throttle-config-ms',
);

export const APP_USE_LOCALE_FOR_DATE_TIME = Symbol(
  'ME-173643-enable-user-locale-support-for-get-date-time',
);

export const APP_ENABLE_NEW_RELIC_ERROR_REPORTING = Symbol(
  'ME-373147-enable-new-relic-error-reporting',
);

export const APP_ENABLE_SENTRY_ERROR_REPORTING = Symbol(
  'ME-373147-enable-sentry-error-reporting',
);

export const GET_ISO_DATE_PART_FIX = Symbol(
  'ME-414656-get-iso-date-part-dst-fix',
);
